"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var config_constants_1 = require("../../../../common/constants/config-constants");
var dialog_config_helper_1 = require("../../../../../../shared/utils/dialog-config-helper");
var overview_content_field_model_1 = require("../../../../common/model/overview-content-field.model");
var overview_card_type_1 = require("../../../../common/model/overview-card-type");
var overview_field_type_1 = require("../../../../common/model/overview-field-type");
var summary_page_configs_helper_service_1 = require("../../../../common/service/summary-page-configs-helper.service");
var base_portfolio_custom_filter_properties_service_1 = require("../../../../../../shared/services/api/summary-pages/base-portfolio-custom-filter-properties.service");
var portfolio_definition_custom_values_service_1 = require("../../../../../../shared/services/api/portfolio-definition-custom-values.service");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var lodash_1 = require("lodash");
var BasePortfolioConfigDialogComponent = /** @class */ (function () {
    function BasePortfolioConfigDialogComponent(summaryPageConfigsHelperService, kbService, dialogRef, sessionDataProvider, portfolioDefinitionCustomValuesService, dialog, basePortfolioCustomFilterPropertiesService, data) {
        this.summaryPageConfigsHelperService = summaryPageConfigsHelperService;
        this.kbService = kbService;
        this.dialogRef = dialogRef;
        this.sessionDataProvider = sessionDataProvider;
        this.portfolioDefinitionCustomValuesService = portfolioDefinitionCustomValuesService;
        this.dialog = dialog;
        this.basePortfolioCustomFilterPropertiesService = basePortfolioCustomFilterPropertiesService;
        this.data = data;
        this.OverviewCardType = overview_card_type_1.OverviewCardType;
        this.OverviewPortfolioFieldType = overview_field_type_1.OverviewPortfolioFieldType;
        this.overviewFieldTypes = config_constants_1.OVERVIEW_PORTFOLIO_FIELD_TYPES;
        this.areValidFilterFields = true;
        this._acceptableFilteringFields = [
            idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER,
            idm_kb_service_client_js_1.MetaFieldType.STRING,
            idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE,
            idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING,
            idm_kb_service_client_js_1.MetaFieldType.INTEGER,
            idm_kb_service_client_js_1.MetaFieldType.DECIMAL,
            idm_kb_service_client_js_1.MetaFieldType.DOCUMENT,
            idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING,
            idm_kb_service_client_js_1.MetaFieldType.DATE,
            idm_kb_service_client_js_1.MetaFieldType.BOOLEAN,
            idm_kb_service_client_js_1.MetaFieldType.MONEY,
            idm_kb_service_client_js_1.MetaFieldType.DATE_TIME,
            idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT,
            idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY,
            idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY,
        ];
        this.itemConfig = data.itemConfig;
        if (!this.itemConfig.fields || !this.itemConfig.fields.length) {
            this.itemConfig.fields = [new overview_content_field_model_1.OverviewContentPortfolioFieldModel(overview_field_type_1.OverviewPortfolioFieldType.FIELD, null)];
        }
        this.cardCategory = data.cardCategory;
        this.rootCategory = data.rootCategory;
    }
    BasePortfolioConfigDialogComponent_1 = BasePortfolioConfigDialogComponent;
    BasePortfolioConfigDialogComponent.getConfig = function (basePortfolioConfig, cardCategory, rootCategory) {
        var dialogConfig = dialog_config_helper_1.DialogConfigHelper.getDialogBasicConfig({ width: '820px' });
        dialogConfig.data = {
            itemConfig: basePortfolioConfig,
            cardCategory: cardCategory,
            rootCategory: rootCategory
        };
        return dialogConfig;
    };
    BasePortfolioConfigDialogComponent.constructInnerFilterForMainEntity = function (mainEntitySystemName, mainEntityFields) {
        var _a;
        return _a = {}, _a[mainEntitySystemName] = mainEntityFields, _a;
    };
    BasePortfolioConfigDialogComponent.constructFilterForSubEntity = function (mainEntitySystemName, mainEntityField) {
        return mainEntitySystemName + "." + mainEntityField;
    };
    BasePortfolioConfigDialogComponent.getMetaFieldName = function (field, currentLanguageId) {
        return field.getDisplayNameMultilingual() && field.getDisplayNameMultilingual().getValue(currentLanguageId) || field.getSystemName();
    };
    BasePortfolioConfigDialogComponent.prototype.ngOnInit = function () {
        this.currentLanguage$ = this.sessionDataProvider.getCurrentLanguage().pipe(operators_1.publishReplay(1), operators_1.refCount());
        this.entityFieldsList$ = this.summaryPageConfigsHelperService.getFieldsByEntity(this.cardCategory).pipe(operators_1.publishReplay(1), operators_1.refCount());
        this.customFields$ = this.portfolioDefinitionCustomValuesService.getCustomFields(this.cardCategory, this.rootCategory).pipe(operators_1.publishReplay(1), operators_1.refCount());
        this.setQuickFilterFields();
        this.setDefaultSortingFields();
        this.setFilterFields();
    };
    BasePortfolioConfigDialogComponent.prototype.setDefaultSortingFields = function () {
        var _this = this;
        this.defaultSortingFieldsList$ = this.entityFieldsList$.pipe(operators_1.map(function (entityFieldsList) {
            return entityFieldsList.filter(function (entityField) {
                return _this.itemConfig.fields.find(function (field) { return field.fieldName === entityField.getSystemName(); });
            });
        }), operators_1.tap(function (sortingFields) {
            if (!sortingFields.find(function (field) { return field.getSystemName() === _this.itemConfig.defaultSortingField; })) {
                _this.itemConfig.defaultSortingField = null;
            }
        }), operators_1.publishReplay(1), operators_1.refCount());
    };
    BasePortfolioConfigDialogComponent.prototype.onDimensionsSelect = function (dimensions) {
        var _this = this;
        if (dimensions.width > this.itemConfig.fields.length) {
            Array.from(Array(dimensions.width - this.itemConfig.fields.length)).forEach(function () {
                _this.itemConfig.fields.push(new overview_content_field_model_1.OverviewContentPortfolioFieldModel(overview_field_type_1.OverviewPortfolioFieldType.FIELD, null));
            });
        }
        else {
            var amountToDelete = this.itemConfig.fields.length - dimensions.width;
            this.itemConfig.fields.splice(dimensions.width - 1, amountToDelete);
        }
    };
    BasePortfolioConfigDialogComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    BasePortfolioConfigDialogComponent.prototype.save = function () {
        if (this.validateFields()) {
            this.dialogRef.close(this.itemConfig);
        }
    };
    BasePortfolioConfigDialogComponent.prototype.setQuickFilterFields = function () {
        this.quickFilterFieldsList$ = this.entityFieldsList$.pipe(operators_1.map(function (entityFieldsList) {
            return entityFieldsList.filter(function (entityField) { return entityField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER
                || entityField.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE; });
        }), operators_1.publishReplay(1), operators_1.refCount());
    };
    BasePortfolioConfigDialogComponent.prototype.setFilterFields = function () {
        var _this = this;
        this.filterFieldsList$ = this.getFilterFields().pipe(operators_1.tap(function (filterFields) {
            if (_this.itemConfig.filterFields && _this.itemConfig.filterFields.length) {
                var selectedFilters_1 = [];
                _this.itemConfig.filterFields.forEach(function (selectedFilterField) {
                    if (typeof selectedFilterField === 'object') {
                        var foundObjectFilter = filterFields.find(function (objectFilter) { return lodash_1.isEqual(objectFilter.key, selectedFilterField); });
                        if (foundObjectFilter) {
                            selectedFilters_1.push(foundObjectFilter.key);
                        }
                    }
                    else {
                        selectedFilters_1.push(selectedFilterField);
                    }
                });
                _this.itemConfig.filterFields = selectedFilters_1;
            }
        }));
    };
    BasePortfolioConfigDialogComponent.prototype.getFilterFields = function () {
        var _this = this;
        var customFilterFields$ = this.getCustomFilterFields();
        var acceptableMetaFields$ = this.getCategoryAcceptableMetaFields(this.cardCategory, this._acceptableFilteringFields);
        return zip_1.zip(this.currentLanguage$, customFilterFields$, acceptableMetaFields$)
            .pipe(operators_1.switchMap(function (_a) {
            var language = _a[0], customFilterFields = _a[1], availableFields = _a[2];
            return _this.constructAvailableFilterFields(language && language.getId(), customFilterFields, availableFields);
        }));
    };
    // ToDo: construct default outer filters for given category
    /**
     * Constructs filter fields for current entity.
     * For sub-entity fields filter is printed as: [Sub-Entity Field Display Name] > [Sub-Entity's Field's Display Name]
     * e.g. Case with sub-entity 'Case Parties' that has a 'Party Role' field will be printed as: Case Parties > Party Role.
     *
     * For main-entity fields filter will be constructed as filter objects of {@link FilterComponent.INNER_FILTER_KEY} type.
     */
    BasePortfolioConfigDialogComponent.prototype.constructAvailableFilterFields = function (languageId, customFilters, availableFields) {
        var _this = this;
        var basePortfolioFilterFields = [];
        var compoundCategoryFieldsFields$ = [];
        if (customFilters && customFilters.length) {
            customFilters.forEach(function (customFilterKey) {
                return basePortfolioFilterFields.push({ key: customFilterKey });
            });
        }
        availableFields.forEach(function (field) {
            if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
                compoundCategoryFieldsFields$.push(_this.constructCategoryFilterFields(field, languageId, _this._acceptableFilteringFields.filter(function (type) { return type !== idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY; })));
            }
            else if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY) {
                // ToDo: change acceptable field types for main entity field when more types are supported.
                // For now portfolio supports only strings and multilingual strings.
                compoundCategoryFieldsFields$.push(_this.constructCategoryFilterFields(field, languageId, [idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING, idm_kb_service_client_js_1.MetaFieldType.STRING]));
            }
            else {
                basePortfolioFilterFields.push({
                    name: BasePortfolioConfigDialogComponent_1.getMetaFieldName(field, languageId),
                    key: field.getSystemName()
                });
            }
        });
        if (compoundCategoryFieldsFields$.length) {
            return zip_1.zip.apply(void 0, compoundCategoryFieldsFields$).pipe(operators_1.map(function (basePortfolioSubFields) {
                basePortfolioSubFields.forEach(function (baseFilterFields) { return basePortfolioFilterFields.push.apply(basePortfolioFilterFields, baseFilterFields); });
                return basePortfolioFilterFields;
            }));
        }
        return of_1.of(basePortfolioFilterFields);
    };
    BasePortfolioConfigDialogComponent.prototype.getCustomFilterFields = function () {
        return this.basePortfolioCustomFilterPropertiesService ?
            this.basePortfolioCustomFilterPropertiesService.getCustomFilterKeys(this.cardCategory) : of_1.of(null);
    };
    BasePortfolioConfigDialogComponent.prototype.getCategoryAcceptableMetaFields = function (category, acceptableFilteringFields) {
        var metaCategory$ = this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(category));
        var metaFields$ = this.kbService.getMetaFields(category);
        return zip_1.zip(metaCategory$, metaFields$).pipe(operators_1.map(function (_a) {
            var metaCategory = _a[0], metaFields = _a[1];
            return metaFields.filter(function (metaField) {
                return acceptableFilteringFields.indexOf(metaField.getType()) !== -1
                    &&
                        metaCategory.getSearchableFieldIds().find(function (searchableField) {
                            return searchableField.getSystemName() === metaField.getSystemName();
                        });
            });
        }));
    };
    BasePortfolioConfigDialogComponent.prototype.constructCategoryFilterFields = function (field, currentLanguageId, acceptableFilteringFields) {
        var acceptableMetaFields$ = this.getCategoryAcceptableMetaFields(field.getCompoundCategorySystemName(), acceptableFilteringFields);
        return acceptableMetaFields$.pipe(operators_1.map(function (compoundCategoryMetaFields) {
            var mainFieldName = BasePortfolioConfigDialogComponent_1.getMetaFieldName(field, currentLanguageId);
            return compoundCategoryMetaFields.map(function (metaField) {
                var fieldName = BasePortfolioConfigDialogComponent_1.getMetaFieldName(metaField, currentLanguageId);
                var portfolioView = { name: mainFieldName + ' > ' + fieldName };
                if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY) {
                    portfolioView.key = BasePortfolioConfigDialogComponent_1
                        .constructInnerFilterForMainEntity(field.getSystemName(), [metaField.getSystemName()]);
                }
                else {
                    portfolioView.key = BasePortfolioConfigDialogComponent_1
                        .constructFilterForSubEntity(field.getSystemName(), metaField.getSystemName());
                }
                return portfolioView;
            });
        }));
    };
    BasePortfolioConfigDialogComponent.prototype.validateFields = function () {
        this.areValidFilterFields = !!this.itemConfig.filterFields && !!this.itemConfig.filterFields.length;
        return this.areValidFilterFields;
    };
    var BasePortfolioConfigDialogComponent_1;
    BasePortfolioConfigDialogComponent = BasePortfolioConfigDialogComponent_1 = __decorate([
        core_1.Component({
            selector: "ejustice-base-portfolio-config-dialog",
            styles: [require('./base-portfolio-config-dialog.component.css')],
            template: require('./base-portfolio-config-dialog.component.html'),
        }),
        __param(6, core_1.Optional()),
        __param(7, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [summary_page_configs_helper_service_1.SummaryPageConfigsHelperService,
            idm_kb_service_client_js_1.KbService,
            material_1.MatDialogRef,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            portfolio_definition_custom_values_service_1.PortfolioDefinitionCustomValuesService,
            material_1.MatDialog,
            base_portfolio_custom_filter_properties_service_1.BasePortfolioCustomFilterPropertiesService, Object])
    ], BasePortfolioConfigDialogComponent);
    return BasePortfolioConfigDialogComponent;
}());
exports.BasePortfolioConfigDialogComponent = BasePortfolioConfigDialogComponent;
//# sourceMappingURL=base-portfolio-config-dialog.component.js.map